import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function PricingSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.impulsodigitalx.shop/cart/45788685926561:1';
  };
  return <section id="pricing" className="bg-[#0B0B1A] py-16 md:py-24 px-4 scroll-mt-10 relative overflow-hidden" data-id="element-93">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-[#00D4FF] opacity-10 blur-[140px] rounded-full pointer-events-none" data-id="element-94" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 rounded-3xl shadow-2xl border-2 border-[#FF00FF]/40 overflow-hidden backdrop-blur-sm" data-id="element-96">
          <div className="bg-gradient-to-r from-[#FF00FF]/20 to-[#00D4FF]/20 text-white text-center py-6 px-4 border-b border-white/10" data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-extrabold flex items-center justify-center gap-3" data-id="element-98">
              <span data-id="element-99">📦</span> Acceso completo
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-100">
            <ul className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-101">
              {['Colección completa', '8 guías prácticas de ciberseguridad', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg md:text-xl font-medium text-gray-200" data-id="element-102">
                  <CheckCircle2 className="w-6 h-6 text-[#00FF66] flex-shrink-0" data-id="element-103" />
                  <span data-id="element-104">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-10" data-id="element-105">
              <p className="text-xl text-gray-500 font-medium mb-2 line-through decoration-red-500 decoration-2" data-id="element-106">
                Precio normal: ARS $49.990
              </p>
              <div className="inline-block bg-[#FF3333]/15 px-8 py-4 rounded-2xl border-2 border-[#FF3333] border-dashed" data-id="element-107">
                <p className="text-4xl md:text-6xl font-extrabold text-[#FF3333]" data-id="element-108">
                  🔥 HOY: ARS $19.990
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-109">
              <CtaButton text="👉 OBTENER ACCESO AHORA" className="w-full md:w-auto md:px-16 md:py-6 md:text-3xl shadow-2xl" onClick={handlePurchase} data-id="element-110" />
              <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-111">
                Pago 100% seguro. Acceso inmediato al material.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}